<template>
    <!-- <div v-if = IsSupervisor> -->
      <ob-modal2 :show.sync="show" :width="800" :backdrop="false">
      <template slot="modal-title">
          <div class="col-md-12 pL0">
              <div class="col-md-11">
                  <h3 class="rcss-heading-3" style="margin: 0px;">Copy Review Link</h3>
              </div>
          </div>
      </template>
      <div slot="modal-body">
        <div>
          <button  class="pull-right"
            style="border:1px solid #fff;background: #337ab7;color: #fff;text-align: center;border-radius:10px;padding:1%"
            @click="copyEmail"><span><img
                style="margin-right: 2px; width:28px !important; height:29px !important; display:inline;"
                :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/icons/ic_copy_white.svg`" />&nbsp; {{ changeText ? 'Copied to clipboard' : 'Copy Email'}}</span></button>
          <div class="email-content" ref="copyData">

            <div class="email-header">
              <h4 style="text-align: center; font-weight: 800;color: #000;">Review {{ content.Employee.Name }}’s {{ GetSectionType() }}</h4>

            </div>
            <p style="margin-bottom: 10px;">Hi {{ GetSAName() }},</p>
            <p style="margin-bottom: 10px;">
              {{ orgName }} has sent you {{ content.Employee.Name }}’s {{ GetSectionType() }} for your review.
              Please use the details below to review it:
            </p>
            <p style="margin-bottom: 10px;">
              <strong style="margin-bottom: 10px;">{{ GetSectionType() }} link:</strong>{{ link }} <br>
              <strong >One-time password:</strong> {{ OTPNumber }}
            </p>
          </div>
        </div>
        <p class="note">
          Note: We have already sent the link to {{ Email() }}.
          If the recipient does not receive the link,
          please share the above link with them.
        </p>
      </div>
      <div slot="modal-footer">
        <ob-button type="secondary" @click="close">Close</ob-button>
      </div>
    </ob-modal2>
  </div>
</template>

<script>
import _ from 'lodash';
import c from 'Vue/Core/constants.js'
export default {
  data() {
    return {
      show: false,
      orgName:'',
      email: '',
      link:'',
      changeText:false
    };
  },
  props:["openModal", "content","copymailsectionType"],

  watch:{
    show(val){
      if(!val){
        // this.show=val
        this.$emit('update:openModal', val)
      }

    },
    openModal(val) {
      if(val) {
        this.show = val
        this.link = `${c.APPLICATIONBASEURL}/app/signature-authority?id=${this.content.Id}&sectionType=${this.copymailsectionType}&noprogress=true`
      }
    }
  },
  created() {
    var loggedInUserObj = JSON.parse(localStorage.getItem('user_details'));
     this.orgName = loggedInUserObj.OrgName
    this.link = `${c.APPLICATIONBASEURL}/app/signature-authority?id=${this.content.Id}&sectionType=${this.copymailsectionType}`
    console.log(this.copymailsectionType, 'copymailsectionType')
  },
  computed :{
    OTPNumber() {
      if(this.copymailsectionType == 'Employer') {
        return this.content.Employer.OTP || 'N/A'
      }else if(this.copymailsectionType == 'AssignedTraining') {
        return this.content.AssignedTraining.OTP || 'N/A'
      }else if(this.copymailsectionType == 'Evaluation') {
        return this.content.Evaluation.OTP || 'N/A'
      }
    }
  },
  methods: {
    GetSAName()
    {
      var name = this.copymailsectionType == 'Employer' ? this.content.Employer.SignatoryAuthority.Name
           : this.copymailsectionType == 'AssignedTraining' ? this.content.AssignedTraining.SignatoryAuthority.Name
           : this.copymailsectionType == 'Evaluation' ? this.content.Evaluation.SignatoryAuthority.Name:'';

      return name;
    },
    GetSectionType()
    {
      return this.copymailsectionType == 'Employer' ? 'Employer Info'
           : this.copymailsectionType == 'AssignedTraining' ? 'Training Plan'
           : this.copymailsectionType == 'Evaluation' ? 'Evaluation':'';
    },
    Email()
    {
      var email = this.copymailsectionType == 'Employer' ? this.content.Employer.SignatoryAuthority.Email
           : this.copymailsectionType == 'AssignedTraining' ? this.content.AssignedTraining.SignatoryAuthority.Email
           : this.copymailsectionType == 'Evaluation' ? this.content.Evaluation.SignatoryAuthority.Email:'';

      return email
    },
    CopySection() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    copyEmail() {
      // Logic to copy email content to clipboard
    },
    copyEmail() {
    this.selectText(this.$refs.copyData);
    this.changeText = true
    setTimeout(() => {
      this.changeText = false
    }, 10000)
    },
    selectText(element) {
    var range;
    if (window.getSelection) {
      range = document.createRange();
      range.selectNode(element);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeRange(range);
    }
  },

  }
};
</script>

<style scoped>
.email-content {
  padding: 20px;
  background-color: #f5f5f5;
}
.email-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}
.note {
  color: #555;
  font-size: 12px;
  margin-top: 10px;
  padding-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/CopyMail.vue